import { StatusMoveDialog } from "./StatusMoveDialog";
import styles from "./Record.module.css";

interface RestoreDialogProps {
  caseId: string;
  caseNo: string;
  title: string;
  onClose: () => void;
  onDone: (sentence: string) => void;
  onClosed?: () => void;
}

/**
 * „Wiederherstellen" (spec 2026-10-15 §5): always back to „In Planung"
 * (Denis, 15.10.2026) — not to the stage the Vorgang was cancelled from. The
 * reason is asked for, not insisted on. What the dialog does is
 * `StatusMoveDialog`'s; this is its sentence.
 */
export function RestoreDialog(props: RestoreDialogProps) {
  return (
    <StatusMoveDialog kind="restore" {...props}>
      <p className={styles.plain}>Der Vorgang steht danach wieder auf ‚In Planung‘.</p>
    </StatusMoveDialog>
  );
}
